import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Table, TextField} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@mui/material/Skeleton";
import { BsThreeDots } from "react-icons/bs";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { IoCloseOutline } from "react-icons/io5";
import TablePagination from "@material-ui/core/TablePagination";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from "@chakra-ui/react";
import Autocomplete from "@mui/material/Autocomplete";
import {
  createRepairer,
  fetchRepairers,
  deleteRepairer,
  updateRepairer, update2Repairer
} from "../../store/action/repairer";
import { ManagementTypes } from '../../utils/ManagementTypes';
import {
  addCommunicationChannelToPerson, createCommunicationChannel,
  getCommunicationChannel,
  getOrganizationDetails,
} from "../../store/action/party";
 import tunisiaData from "../../utils/tunisiaData";
import {validateInput} from "../../utils/inputValidation";
import ErrorsAlert from "../../utils/errorsAlert";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
    whiteSpace: "nowrap",
  },
  autocompleteTag: {
    fontFamily: "Poppins, sans-serif",
    backgroundColor: "rgba(240, 243, 199, 1)",
    color: "rgba(60, 101, 86, 1)",
    border: "none",
    fontSize: "0.75rem",
    padding: "2px 6px",
    alignItems: "center",
    justifyContent: "center",
    margin: "2px",
    borderRadius: "16px",
    display: "inline-block",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  paper: {
    //height: "100%",
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    height: "48px",
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },

  tableSortLabel: {
    color: "rgba(32, 29, 35, 1)",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  inputContainer: {
    border: "1px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "188px",
    height: "30px",
    borderRadius: 5,
  },
  naText: {
    color: "rgb(145, 145, 145)",
  },
  line: {
    height: "2px",
    backgroundColor: "rgba(243, 246, 249, 1)",
    width: "100%",
    marginBottom: "16px",
  },
  dialog: {
    width: "600px",
    height: "300px",
    backgroundColor: "#ffffff",
  },
  dialogTitle: {
    backgroundColor: "rgba(244, 244, 244, 1)",
    width: "600px",
    height: "60px",
    color: "#464E5F",
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 600,
  },
  closeButton: {
    cursor: "pointer",
    textAlign: "right",
    alignItems: "center",
  },
  dialogContent: {
    marginTop: "20px",
    padding: "20px",
  },
  inputLabel: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  dialogInput: {
    width: "100%",
    height: "36px",
    padding: "8px 12px",
    fontFamily: "Poppins",
    fontSize: "14px",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    backgroundColor: "rgba(243, 246, 249, 1)",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(60, 101, 86, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  /////////////////////////////////////////
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    padding: "5px",
    width: "240px",
    height: "36px",
    borderRadius: "4px",
  },
  selectInputDialog: {
    width: "100%",
    border: "0",
    padding: "5px",
    background: "rgba(243, 246, 249, 1)",
    height: "29.69px",
    borderRadius: 5,
  },

  optionItem: {
    width: "100%",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    specialInput: {
      color: "rgba(24, 28, 50, 0.58)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: 500,
      textAlign: "right",
      backgroundColor: "rgba(243, 246, 249, 1)",
      border: "none",
      width: "209px",
      height: "28px",
    },
  },
}));

export default function Repairer() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [repairers, setRepairers] = useState([]);
  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [managementTypes, setManagementTypes] = useState([]);
  const [repairerName, setRepairerName] = useState("");
  const [taxId, setTaxId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [codePI, setCodePI] = useState("");
  const [scope, setScope] = useState([]);
  const [scopeFilter, setScopeFilter] = useState([]);
  const [region, setRegion] = useState([]);
  const [gouvernorat, setGouvernorat] = useState([]);
  const [availableRegions, setAvailableRegions] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(null);
  const [filteredRepairers, setFilteredRepairers] = useState(repairers);
  const [dataFetched, setDataFetched] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedRepairer, setSelectedRepairer] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [updatedRepairerData, setupdatedRepairerData] = useState();
  const [updatedRepairerName, setupdatedRepairerName] = useState("");
  const [updatedTaxId, setupdatedTaxId] = useState("");
  const [updatedPhoneNumber, setupdatedPhoneNumber] = useState("");
  const [updatedEmail, setupdatedEmail] = useState("");
  const [updatedCodePI, setupdatedCodePI] = useState("");
  const [updatedScope, setupdatedScope] = useState([]);
  const [updatedRegion, setupdatedRegion] = useState([]);
  const [updatedGouvernorat, setupdatedGouvernorat] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [repairerToDelete, setRepairerToDelete] = useState(null);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setManagementTypes(ManagementTypes);
  }, [dispatch]);

  const handleGouvernoratChange = (event, value, isUpdate = false) => {
    const removedGouvernorats = (isUpdate ? updatedGouvernorat : gouvernorat).filter((g) => !value.includes(g));

    // rmv regions associated with removed gouvernorats
    const updatedRegions = (isUpdate ? updatedRegion : region).filter(
        (reg) => !removedGouvernorats.some((g) => tunisiaData[g].includes(reg))
    );

    if (isUpdate) {
      setupdatedGouvernorat(value);
      setupdatedRegion(updatedRegions);
    } else {
      setGouvernorat(value);
      setRegion(updatedRegions);
    }

    // upd available regions based on selected gouvernorats
    const newRegions = value.flatMap((g) => tunisiaData[g] || []);
    setAvailableRegions(newRegions);
  };

  const handleRegionChange = (event, value, isUpdate = false) => {
    if (isUpdate) {
      setupdatedRegion(value);
    } else {
      setRegion(value);
    }
  };

  const handleCreateRepairer = async () => {
    try {
      const organizationData = {
        phoneNumber: phoneNumber,
        organizationName: repairerName,
        email: email,
        taxId: taxId,
        codePI: codePI,
      };

      const repairerData = {
        region: region,
        gouvernorat: gouvernorat,
        scope: scope.map((item) => item.label),
        //equipments: ["eq1", "eq2"]
      };
      
      const repairer = await createRepairer(organizationData, repairerData);
      
      console.log("Repairer Created Successfully:", repairer);
      setOpenCreateDialog(false);
      await fetchRepairersWithDetails()
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getPhone = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
    const phoneValue = Channel ? Channel.communicationChannel.value : "N/A"
    return phoneValue
  }

  const getEmail = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "EMAILCONTACT" &&  party.status === "ACTIVE");
    const emailValue = Channel ? Channel.communicationChannel.value : "N/A"
    return emailValue
  }

  const fetchRepairersWithDetails = async () => {
    setLoading(true);
    try {
      const repairersList = await dispatch(fetchRepairers());
      const updatedRepairers = await Promise.all(repairersList.map(async (repairer) => {
        const associatedParty = repairer.associatedParty;

        if (associatedParty) {
          const org = await getOrganizationDetails(associatedParty);
          const communicationChannels = org?.partyCommunicationChannels || [];

          const phoneNumber = getPhone(communicationChannels);
          const email = getEmail(communicationChannels);

          return {
            ...repairer,
            organizationName: org ? org.organizationName : 'Unknown',
            taxId: org ? org.taxId : '',
            phoneNumber,
            email,
          };
        } else {
          console.warn(`Repairer ${repairer.id} has no associated party.`);
          return {
            ...repairer,
            email: "N/A",
            phoneNumber: "N/A",
          };
        }
      }));

      setRepairers(updatedRepairers);
      setFilteredRepairers(updatedRepairers);
    } catch (error) {
      console.error("Error fetching repairers and details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepairersWithDetails();
  }, []);

  useEffect(() => {
    const newPage = Math.floor(repairers?.length / rowsPerPage);
    setPage(Math.min(newPage, page));
  }, [repairers?.length, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    const filtered = repairers.filter((repairer) => {
      const matchesName = repairer.organizationName
        ?.toLowerCase()
        .includes(nameFilter.toLowerCase());
      const matchesEmail = repairer.email
        ?.toLowerCase()
        .includes(emailFilter.toLowerCase());
      const matchesScope =
          scopeFilter.length === 0 ||
          scopeFilter.some((s) =>
          repairer.caracteristiques.some(
            (item) => item.key === "SCOPE" && s.label === item.value
          )
        );
      return matchesName && matchesEmail && matchesScope;
    });

    setFilteredRepairers(filtered);
  }, [nameFilter, emailFilter, scopeFilter]);

  const headRows = [
    {
      id: "repairer",
      align: "center",
      label: "Garage",
      width: "25%"
    },
    {
      id: "email",
      align: "center", 
      label: "Email",
      width: "25%"
    },
    {
      id: "tel",
      align: "center",
      label: "Tél",
      width: "15%"
    },
    {
      id: "perimetre",
      align: "center",
      label: "Périmètre",
      width: "25%"
    },
    {
      id: "btn",
      align: "center",
      width: "10%"
    },
  ];
  function renderField(field) {
    return field ? field : <span className={classes.naText}>N/A</span>;
  }

  const handleCreateOpen = () => setOpenCreateDialog(true);
  const handleCreateClose = () => setOpenCreateDialog(false);
  const handleViewOpen = () => setOpenViewDialog(true);
  const handleViewClose = () => setOpenViewDialog(false);
  const handleEditOpen = () => setOpenEditDialog(true);
  const handleEditClose = () => setOpenEditDialog(false);

  const handleDeleteRepairer = (repairer) => {
    setRepairerToDelete(repairer);
    setOpenDeleteDialog(true);
  };

  const confirmDeleteRepairer = async () => {
    if (repairerToDelete) {
      try {
        await deleteRepairer(repairerToDelete._id);
        setOpenDeleteDialog(false);
        setRepairerToDelete(null);
        await fetchRepairersWithDetails();
      } catch (error) {
        console.error("Error deleting repairer:", error);
      }
    }
  };

  const cancelDeleteRepairer = () => {
    setOpenDeleteDialog(false);
    setRepairerToDelete(null);
  };

  const handleEditSubmit = async () => {
    try {
      const updatedRepairer = {
        ...selectedRepairer,
        organizationName: updatedRepairerName,
        taxId: updatedTaxId,
        phoneNumber: updatedPhoneNumber,
        email: updatedEmail,
        caracteristiques: [
          ...selectedRepairer.caracteristiques.filter(
        (item) =>
          item.key !== "SCOPE" &&
          item.key !== "REGION" &&
          item.key !== "GOUVERNORAT"
          ),
          ...updatedScope.map((item) => ({ key: "SCOPE", value: item.label })),
          ...updatedRegion.map((item) => ({ key: "REGION", value: item })),
          ...updatedGouvernorat.map((item) => ({
        key: "GOUVERNORAT",
        value: item,
          })),
        ],
      };

      await updateRepairer(updatedRepairer._id,updatedRepairer);
      setOpenEditDialog(false);
      await fetchRepairersWithDetails();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (selectedRepairer) {
      setupdatedRepairerName(selectedRepairer.organizationName || '');
      setupdatedTaxId(selectedRepairer.taxId || '');
      setupdatedPhoneNumber(selectedRepairer.phoneNumber || '');
      setupdatedEmail(selectedRepairer.email || '');
      setupdatedCodePI(selectedRepairer.code || '');
      setupdatedScope(selectedRepairer.caracteristiques?.filter(item => item.key === "SCOPE").map(item => ({ label: item.value })) || []);
      setupdatedRegion(selectedRepairer.caracteristiques?.filter(item => item.key === "REGION").map(item => item.value) || []);
      setupdatedGouvernorat(selectedRepairer.caracteristiques?.filter(item => item.key === "GOUVERNORAT").map(item => item.value) || []);
      setupdatedRepairerData({
        ...selectedRepairer,
        organizationName: updatedRepairerName,
        taxId: updatedTaxId,
        phoneNumber: updatedPhoneNumber,
        email: updatedEmail,
        code : updatedCodePI ,
        scope: updatedScope,
        region: updatedRegion,
        gouvernorat: updatedGouvernorat
      });
    }
  }, [selectedRepairer]);

  const handleScopeChange = (event, newValue) => {
    setScope(newValue);
  };

  const handleScopeFilterChange = (event, newValue) => {
    setScopeFilter(newValue);
  };

  const handleDropdownClick = (index) => {
    setDropdownVisible((prevState) => (prevState === index ? null : index));
  };

  const truncateLabel = (label) =>
    label.length > 14 ? `${label.substring(0, 12)}..` : label;

  function handlePhoneNumberChange(event) {
    const allowedChars = /^[0-9]+$/;
    const newValue = event.target.value.replace(/[^0-9]/g, "");

    if (newValue.length > 15) {
      return;
    }
    setPhoneNumber(newValue);
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "40px",
            }}
          >
            <div className={classes.titre} style={{ width: "18%" }}>
              Liste des réparateurs
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <div
                  className={classes.titreLabel}
                  style={{ fontWeight: 600, whiteSpace: "nowrap" }}
                >
                  Filtrer par
                </div>
                <div
                  className={classes.titreLabel}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  Périmètre
                  <Autocomplete
                    multiple
                    style={{marginLeft: "10px" }}
                    id="Typologie"
                    options={managementTypes.map((type) => ({
                      label: type.label,
                      value: type,
                    }))}
                    value={scopeFilter.map((item) => ({
                      label: item.label,
                      value: item,
                    }))}
                    size="small"
                    onChange={(event, newValue) => {
                      handleScopeFilterChange(
                        null,
                        newValue.map((item) => item.value)
                      );
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        className={`${props.className} ${classes.optionItem}`}
                      >
                        {option.label}
                      </li>
                    )}
                    renderTags={(tagValue, getTagProps) => {
                      const visibleTag = tagValue[0];
                      const hiddenTags = tagValue.slice(1);

                      return (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                          }}
                        >
                          {visibleTag && (
                            <span
                              {...getTagProps({ index: 0 })}
                              className={classes.autocompleteTag}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                backgroundColor: "rgba(240, 243, 199, 1)",
                                color: "rgba(60, 101, 86, 1)",
                                padding: "2px 6px",
                                borderRadius: "12px",
                                fontSize: "0.75rem",
                                margin: "2px",
                              }}
                            >
                              {truncateLabel(visibleTag.label)}
                              <span
                                className={classes.deleteIcon}
                                style={{
                                  marginLeft: "4px",
                                  cursor: "pointer",
                                  color: "rgba(60, 101, 86, 1)",
                                }}
                                onClick={() => {
                                  const newValue = tagValue.filter(
                                    (_, i) => i !== 0
                                  );
                                  handleScopeFilterChange(
                                    null,
                                    newValue.map((item) => item.value)
                                  );
                                }}
                              >
                                ✕
                              </span>
                            </span>
                          )}
                          {hiddenTags.length > 0 && (
                            <span
                              className={classes.autocompleteTag}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                backgroundColor: "rgba(240, 243, 199, 1)",
                                color: "rgba(60, 101, 86, 1)",
                                padding: "2px 6px",
                                borderRadius: "12px",
                                fontSize: "0.75rem",
                                margin: "2px",
                              }}
                              title={hiddenTags
                                .map((tag) => tag.label)
                                .join(", ")}
                            >
                              ... ({hiddenTags.length})
                            </span>
                          )}
                          {tagValue.length > 0 && (
                            <span
                              className={classes.deleteAllIcon}
                              style={{
                                marginLeft: "8px",
                                cursor: "pointer",
                                color: "rgba(60, 101, 86, 1)",
                              }}
                              onClick={() => handleScopeFilterChange(null, [])}
                            >
                              ✕
                            </span>
                          )}
                        </div>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.inputContainer}
                          InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                          endAdornment: null,
                        }}
                      />
                    )}
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      "& .MuiOutlinedInput-root": {
                        p: 1,
                        height: "fit-content",
                        backgroundColor: "rgba(243, 246, 249, 1)",
                        fontSize: "0.75rem",
                        display: "flex",
                        fontFamily: "Poppins",
                        border: "none",
                        alignItems: "center",
                        justifyContent: "center",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                      "& .MuiAutocomplete-popupIndicator": {
                        display: "none",
                      },
                      "& .MuiAutocomplete-tag": {
                        bgcolor: "rgba(240, 243, 199, 1)",
                        color: "rgba(60, 101, 86, 1)",
                        border: "none",
                        borderColor: "primary.light",
                        fontSize: "0.75rem",
                        padding: "2px 6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2px",
                      },
                      "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                        color: "rgba(60, 101, 86, 1)",
                        "&:hover": {
                          color: "rgba(60, 101, 86, 1)",
                        },
                      },
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>

                <div
                  className={classes.titreLabel}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Garage
                  <input
                    type="text"
                    className={classes.inputContainer}
                    style={{ width: "120px", marginLeft: "10px" }}
                    onChange={(e) => setNameFilter(e.target.value)}
                  />
                </div>
                <div
                  className={classes.titreLabel}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Email
                  <input
                    type="text"
                    className={classes.inputContainer}
                    style={{ width: "120px", marginLeft: "10px" }}
                    onChange={(e) => setEmailFilter(e.target.value)}
                  />
                </div>
              </div>
              <Box display="flex" alignItems="center" gap="10px">
                <Button
                  style={{
                    width: "110px",
                    height: "37px",
                    color: "rgba(186, 200, 9, 1)",
                    borderColor: "rgba(186, 200, 9, 1)",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderRadius: "5px",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "11px",
                    lineHeight: "16px",
                  }}
                  onClick={handleCreateOpen}
                >
                  Créer reprateur
                </Button>
              </Box>
            </div>
          </div>

          <Table
              style={{ tableLayout: "fixed", width: "100%" }}
              aria-labelledby="tableTitle"
              size="small"
          >
            <tr>
              {headRows.map((row) => (
               <TableCell
               key={row.id}
               height="43px"
               align={row.align}
               className={classes.tableHeadRows}
               style={{ width: row.width }}
             >
               {row.label}
             </TableCell>
              ))}
            </tr>
            {loading
                ? [...Array(10)].map((_, index) => (
                    <tr key={index} hover style={{ height: "48px" }}>
                      <TableCell align="left" className={classes.tableCellSmall} style={{ width: "25%" }}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellSmall} style={{ width: "25%" }}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellSmall} style={{ width: "15%" }}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellSmall} style={{ width: "25%" }}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="right" className={classes.tableCellSmall} style={{ width: "10%" }} >
                        <button className={classes.viewBtn}>
                          <BsThreeDots />
                        </button>
                      </TableCell>
                    </tr>
                ))
                : filteredRepairers?.length > 0
                    ? filteredRepairers
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((repairer, index) => {
                          return (
                              <tr
                                  key={repairer?.associatedParty || index}
                                  hover
                                  style={{
                                    height: "50px",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                  }}
                              >
                                <TableCell
                                    align="center"
                                    className={classes.tableCellSmall}
                                >
                                  {renderField(repairer?.organizationName)}
                                </TableCell>
                                <TableCell
                                    align="center"
                                    className={classes.tableCellSmall}
                                >
                                  {renderField(repairer?.email)}
                                </TableCell>
                                <TableCell
                                    align="center"
                                    className={classes.tableCellSmall}
                                >
                                  {renderField(repairer?.phoneNumber)}
                                </TableCell>
                                <TableCell
                                    align="center"
                                    className={classes.tableCellSmall}
                                    sx={{
                                      fontFamily: "Poppins, sans-serif",
                                      p: 1,
                                      height: "fit-content",
                                      backgroundColor: "rgba(243, 246, 249, 1)",
                                      fontSize: "0.75rem",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      border: "none",
                                    }}
                                >
                                  {repairer.caracteristiques
                                      ?.filter((item) => item?.key === "SCOPE")
                                      .map((scopeItem, index) => (
                                          <span
                                              key={index}
                                              style={{
                                                fontFamily: "Poppins, sans-serif",
                                                backgroundColor: "rgba(240, 243, 199, 1)",
                                                color: "rgba(60, 101, 86, 1)",
                                                border: "none",
                                                fontSize: "10.69px",
                                                fontWeight: 500,
                                                padding: "2px 6px",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "5px",
                                                borderRadius: "51px",
                                                width: "fit-content",
                                                height: "26px",
                                              }}
                                          >
                      {scopeItem?.value}
                    </span>
                                      ))}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    className={classes.tableCellSmall}
                                >
                                  <button
                                      className={classes.viewBtn}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDropdownClick(index);
                                      }}
                                  >
                                    <BsThreeDots />
                                  </button>
                                  {dropdownVisible === index && (
                                      <div className={classes.dropdownMenu}>
                                        <div
                                            className={classes.dropdownItem}
                                            onClick={(e) => {
                                              setSelectedRepairer(repairer);
                                              handleViewOpen();
                                            }}
                                        >
                                          Détail
                                        </div>
                                        <div
                                            className={classes.dropdownItem}
                                            onClick={(e) => {
                                              setSelectedRepairer(repairer);
                                              handleEditOpen();
                                            }}
                                        >
                                          Modifier
                                        </div>
                                        <div
                                            className={classes.dropdownItem}
                                            onClick={(e) => {
                                              handleDeleteRepairer(repairer);
                                            }}
                                        >
                                          Supprimer
                                        </div>
                                      </div>
                                  )}
                                </TableCell>
                              </tr>
                          );
                        })
                    : (
                        <tr>
                          <TableCell
                              align="center"
                              style={{
                                fontFamily: 'Poppins',
                                fontWeight: 400,
                                fontSize:  15,
                                lineHeight: '22.5px',
                                color: 'rgba(70, 78, 95, 1)',
                                padding: '20px'
                              }}
                              colSpan="6"
                          >
                            Aucun garage disponible
                          </TableCell>
                        </tr>
                    )}
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={filteredRepairers?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "18px",
              color: "rgba(32, 18, 70, 1)",
            }}
            labelRowsPerPage="Lignes par page"
          />
        </div>
      </Paper>

      <Dialog
        open={openCreateDialog}
        onClose={handleCreateClose}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ backgroundColor: "rgba(243, 246, 249, 1)",  display: "flex", justifyContent: "space-between" }}
        >
          Création Réparateur
          <IoCloseOutline
            className={classes.closeButton}
            size={24}
            onClick={handleCreateClose}
          />
        </DialogTitle>
        <DialogContent>
          <Accordion allowMultiple defaultIndex={[0, 1, 2, 3]}>
            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Informations générales
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Nom Réparateur
                      </label>
                      <input
                        className={classes.styleInput}
                        //style={{width: "530px"}}
                        value={repairerName}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setRepairerName(e.target.value);
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Code TVA
                      </label>
                      <input
                        className={classes.styleInput}
                        //style={{width: "530px"}}
                        value={taxId}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setTaxId(e.target.value);
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        N° Tél
                      </label>
                      <input
                        className={classes.styleInput}
                        value={phoneNumber}
                        onChange = {handlePhoneNumberChange}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Email
                      </label>
                      <input
                          type="email"
                        className={classes.styleInput}
                        value={email}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setEmail(e.target.value);
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Code_PI
                      </label>
                      <input
                        className={classes.styleInput}
                        value={codePI}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setCodePI(e.target.value);
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                    
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Périmètre de gestion
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Typologie de sinistre
                    </label>
                    <Autocomplete
                      multiple
                      id="Typologie"
                      options={managementTypes}
                      value={scope}
                      size="small"
                      onChange={handleScopeChange}
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            //placeholder: selectedDAAQs && selectedDAAQs.length<1 ?'Typologie de sinistre':'',
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          fontFamily: "Poppins",
                          border: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(60, 101, 86, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(60, 101, 86, 1)",
                          "&:hover": {
                            color: "rgba(60, 101, 86, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) => option === value}
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Région et gouvernorat
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{marginLeft: "1rem"}}>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                  >
                    <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                    >
                      Gouvernorat
                    </label>
                    <Autocomplete
                        multiple
                        id="gouvernorat-select"
                        options={Object.keys(tunisiaData)}
                        value={gouvernorat}
                        size="small"
                        onChange={handleGouvernoratChange}
                        renderOption={(props, option) => (
                            <li
                                {...props}
                                className={`${props.className} ${classes.optionItem}`}
                            >
                              {option}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                  endAdornment: null,
                                  classes: {
                                    root: classes.selectInputDialog,
                                  },
                                }}
                            />
                        )}
                        sx={{
                          fontFamily: "Poppins, sans-serif",
                          "& .MuiOutlinedInput-root": {
                            p: 1,
                            height: "fit-content",
                            backgroundColor: "rgba(243, 246, 249, 1)",
                            fontSize: "0.75rem",
                            display: "flex",
                            fontFamily: "Poppins",
                            border: "none",
                            alignItems: "center",
                            justifyContent: "center",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-tag": {
                            bgcolor: "rgba(240, 243, 199, 1)",
                            color: "rgba(60, 101, 86, 1)",
                            border: "none",
                            borderColor: "primary.light",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "2px",
                          },
                          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                            color: "rgba(60, 101, 86, 1)",
                            "&:hover": {
                              color: "rgba(60, 101, 86, 1)",
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option === value}
                    />
                  </div>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                  >
                    <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                    >
                      Région
                    </label>
                    <Autocomplete
                        multiple
                        id="region-select"
                        options={availableRegions}
                        value={region}
                        size="small"
                        onChange={handleRegionChange}
                        renderOption={(props, option) => (
                            <li
                                {...props}
                                className={`${props.className} ${classes.optionItem}`}
                            >
                              {option}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                  endAdornment: null,
                                  classes: {
                                    root: classes.selectInputDialog,
                                  },
                                }}
                            />
                        )}
                        sx={{
                          fontFamily: "Poppins, sans-serif",
                          "& .MuiOutlinedInput-root": {
                            p: 1,
                            height: "fit-content",
                            backgroundColor: "rgba(243, 246, 249, 1)",
                            fontSize: "0.75rem",
                            display: "flex",
                            fontFamily: "Poppins",
                            border: "none",
                            alignItems: "center",
                            justifyContent: "center",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-tag": {
                            bgcolor: "rgba(240, 243, 199, 1)",
                            color: "rgba(60, 101, 86, 1)",
                            border: "none",
                            borderColor: "primary.light",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "2px",
                          },
                          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                            color: "rgba(60, 101, 86, 1)",
                            "&:hover": {
                              color: "rgba(60, 101, 86, 1)",
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option === value}
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </DialogContent>
        <DialogActions>
          <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 54, 54, 1)",
                background: "rgba(255, 229, 229, 1)",
                width: "62px",
                height: "26px",
                borderRadius: "5.38px",
                marginRight: "10px",
                "&:hover": {
                  background: "rgba(255, 229, 229, 1)",
                },
              }}
              onClick={handleCreateClose}
              color="secondary"
          >
            Annuler
          </Button>
          <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
                width: "61.08px",
                height: "26.71px",
                borderRadius: "5.38px",
                marginRight: "10px",
                "&:hover": {
                  background: "rgba(187, 200, 8, 1)",
                },
              }}
              onClick={handleCreateRepairer}
              color="primary"
          >
            Valider
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
          open={openViewDialog}
          onClose={handleViewClose}
          classes={{paper: classes.dialogPaper}}
      >
        <DialogTitle
            className={classes.dialogTitle}
            style={{backgroundColor: "rgba(243, 246, 249, 1)", display: "flex", justifyContent: "space-between"}}
        >
          Détail Réparateur
          <IoCloseOutline
              className={classes.closeButton}
              size={24}
              onClick={handleViewClose}
          />
        </DialogTitle>
        <DialogContent>
          <Accordion allowMultiple defaultIndex={[0, 1, 2, 3]}>
            <AccordionItem>
              <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
              >
                <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                />
                <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                >
                  Informations générales
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{marginLeft: "1rem"}}>
                  <div
                      style={{display: "flex", justifyContent: "space-between"}}
                  >
                    <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                    >
                      <label
                          className={classes.cardText}
                          style={{marginBottom: "0.5rem"}}
                      >
                        Nom Réparateur
                      </label>
                      <input
                          className={classes.styleInput}
                          //style={{width: "530px"}}
                          value={selectedRepairer?.organizationName}
                          disabled
                      />
                    </div>
                    <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                    >
                      <label
                          className={classes.cardText}
                          style={{marginBottom: "0.5rem"}}
                      >
                        Code TVA
                      </label>
                      <input
                          className={classes.styleInput}
                          //style={{width: "530px"}}
                          value={selectedRepairer?.taxId}
                          disabled
                      />
                    </div>
                  </div>
                  <div
                      style={{display: "flex", justifyContent: "space-between"}}
                  >
                    <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                    >
                      <label
                          className={classes.cardText}
                          style={{marginBottom: "0.5rem"}}
                      >
                        N° Tél
                      </label>
                      <input
                          className={classes.styleInput}
                          value={selectedRepairer?.phoneNumber}
                          disabled
                      />
                    </div>
                    <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                    >
                      <label
                          className={classes.cardText}
                          style={{marginBottom: "0.5rem"}}
                      >
                        Email
                      </label>
                      <input
                          className={classes.styleInput}
                          value={selectedRepairer?.email}
                          disabled
                      />
                    </div>
                  </div>
                  <div
                      style={{display: "flex", justifyContent: "space-between"}}
                  >
                    <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                    >
                      <label
                          className={classes.cardText}
                          style={{marginBottom: "0.5rem"}}
                      >
                        Code_PI
                      </label>
                      <input
                          className={classes.styleInput}
                          value={selectedRepairer?.code}
                          disabled
                      />
                    </div>
                    
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
              >
                <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                />
                <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                >
                  Périmètre de gestion
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Typologie de sinistre
                    </label>
                    <Autocomplete
                      multiple
                      id="Typologie"
                      options={managementTypes}
                      value={
                        selectedRepairer?.caracteristiques
                          ?.filter((item) => item.key === "SCOPE")
                          .map((item) => ({ label: item.value })) || []
                      }
                      size="small"
                      disabled
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          fontFamily: "Poppins",
                          border: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(60, 101, 86, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(60, 101, 86, 1)",
                          "&:hover": {
                            color: "rgba(60, 101, 86, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) => option.label === value.label}
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Région et gouvernorat
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Gouvernorat
                    </label>
                    <Autocomplete
                      multiple
                      id="gouvernorat-select"
                      options={Object.keys(tunisiaData).filter(
                        (g) => !gouvernorat.includes(g)
                      )}
                      value={
                        selectedRepairer?.caracteristiques
                          ?.filter((item) => item.key === "GOUVERNORAT")
                          .map((item) => ({ label: item.value })) || []
                      }
                      size="small"
                      disabled
                       renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          fontFamily: "Poppins",
                          border: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(60, 101, 86, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(60, 101, 86, 1)",
                          "&:hover": {
                            color: "rgba(60, 101, 86, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) => option.label === value.label}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Région
                    </label>
                    <Autocomplete
                      multiple
                      id="region-select"
                      options={availableRegions}
                      value={
                        selectedRepairer?.caracteristiques
                          ?.filter((item) => item.key === "REGION")
                          .map((item) => ({ label: item.value })) || []
                      }
                      size="small"
                      disabled
                       renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          fontFamily: "Poppins",
                          border: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(60, 101, 86, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(60, 101, 86, 1)",
                          "&:hover": {
                            color: "rgba(60, 101, 86, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) => option.label === value.label}
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </DialogContent>
        <DialogActions>
          <Button
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              lineHeight: "16.14px",
              textAlign: "left",
              color: "rgba(255, 255, 255, 1)",
              background: "rgba(60, 101, 86, 1)",
              width: "61.08px",
              height: "26.71px",
              borderRadius: "5.38px",
              marginRight: "10px",
              "&:hover": {
                background: "rgba(187, 200, 8, 1)",
              },
            }}
            onClick={handleViewClose}
            color="primary"
          >
            Valider
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openEditDialog}
        onClose={handleEditClose}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ backgroundColor: "rgba(243, 246, 249, 1)",  display: "flex", justifyContent: "space-between" }}
        >
          Modifier Réparateur
          <IoCloseOutline
            className={classes.closeButton}
            size={24}
            onClick={handleEditClose}
          />
        </DialogTitle>
        <DialogContent>
          <Accordion allowMultiple defaultIndex={[0, 1, 2, 3]}>
            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Informations générales
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Nom Réparateur
                      </label>
                      <input
                      className={classes.styleInput}
                      name="organizationName"
                      value={updatedRepairerName}
                      onChange={(e) => {
                        if (validateInput(e.target.value)) {
                          setupdatedRepairerName(e.target.value);
                          setupdatedRepairerData((prevData) => ({
                            ...prevData,
                            organizationName: e.target.value,}
                          ))
                          setErrors([]);
                        } else {
                          setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                        }
                      }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Code TVA
                      </label>
                      <input
                        className={classes.styleInput}
                        //style={{width: "530px"}}
                        value={updatedTaxId}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setupdatedTaxId(e.target.value);
                            setupdatedRepairerData((prevData) => ({
                              ...prevData,
                              taxId: e.target.value,
                            }));
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        N° Tél
                      </label>
                      <input
                        className={classes.styleInput}
                        value={updatedPhoneNumber}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const sanitizedValue = inputValue.replace(/[^0-9]/g, "").slice(0, 15);
                          setupdatedPhoneNumber(sanitizedValue);
                          setupdatedRepairerData((prevData) => ({
                            ...prevData,
                            phoneNumber: sanitizedValue || prevData.phoneNumber,
                          }));
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Email
                      </label>
                      <input
                          type="email"
                          className={classes.styleInput}
                        value={updatedEmail}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setupdatedEmail(e.target.value);
                            setupdatedRepairerData((prevData) => ({
                              ...prevData,
                              email: e.target.value,
                            }));
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Code_PI
                      </label>
                      <input
                        className={classes.styleInput}
                        value={updatedCodePI}
                        onChange={(e) => {
                          if (validateInput(e.target.value)) {
                            setupdatedCodePI(e.target.value);
                            setupdatedRepairerData((prevData) => ({
                              ...prevData,
                              codePI: e.target.value,
                            }));
                            setErrors([]);
                          } else {
                            setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                          }
                        }}
                      />
                      <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                    </div>
                     
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Périmètre de gestion
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Typologie de sinistre
                    </label>
                    <Autocomplete
                      multiple
                      id="Typologie"
                      options={managementTypes}
                      value={updatedScope}
                      onChange={(e, value) => {
                        setupdatedScope(value);
                        setupdatedRepairerData((prevData) => ({
                          ...prevData,
                          scope: value,
                        }));
                      }}                      size="small"
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          fontFamily: "Poppins",
                          border: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(60, 101, 86, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(60, 101, 86, 1)",
                          "&:hover": {
                            color: "rgba(60, 101, 86, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.label
                      }
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(60, 101, 86, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Région et gouvernorat
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{marginLeft: "1rem"}}>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                  >
                    <label
                        className={classes.cardText}
                        style={{marginBottom: "0.5rem"}}
                    >
                      Gouvernorat
                    </label>
                    <Autocomplete
                        multiple
                        id="gouvernorat-select"
                        options={Object.keys(tunisiaData)}
                        value={updatedGouvernorat}
                        size="small"
                        onChange={(e, value) => handleGouvernoratChange(e, value, true)}
                        renderOption={(props, option) => (
                            <li
                                {...props}
                                className={`${props.className} ${classes.optionItem}`}
                            >
                              {option}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                  endAdornment: null,
                                  classes: {
                                    root: classes.selectInputDialog,
                                  },
                                }}
                            />
                        )}
                        sx={{
                          fontFamily: "Poppins, sans-serif",
                          "& .MuiOutlinedInput-root": {
                            p: 1,
                            height: "fit-content",
                            backgroundColor: "rgba(243, 246, 249, 1)",
                            fontSize: "0.75rem",
                            display: "flex",
                            fontFamily: "Poppins",
                            border: "none",
                            alignItems: "center",
                            justifyContent: "center",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-tag": {
                            bgcolor: "rgba(240, 243, 199, 1)",
                            color: "rgba(60, 101, 86, 1)",
                            border: "none",
                            borderColor: "primary.light",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "2px",
                          },
                          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                            color: "rgba(60, 101, 86, 1)",
                            "&:hover": {
                              color: "rgba(60, 101, 86, 1)",
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option === value}
                    />
                  </div>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                  >
                    <label
                        className={classes.cardText}
                        style={{marginBottom: "0.5rem"}}
                    >
                      Région
                    </label>
                    <Autocomplete
                        multiple
                        id="region-select"
                        options={availableRegions}
                        value={updatedRegion}
                        size="small"
                        onChange={(e, value) => handleRegionChange(e, value, true)}
                        renderOption={(props, option) => (
                            <li
                                {...props}
                                className={`${props.className} ${classes.optionItem}`}
                            >
                              {option}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                  endAdornment: null,
                                  classes: {
                                    root: classes.selectInputDialog,
                                  },
                                }}
                            />
                        )}
                        sx={{
                          fontFamily: "Poppins, sans-serif",
                          "& .MuiOutlinedInput-root": {
                            p: 1,
                            height: "fit-content",
                            backgroundColor: "rgba(243, 246, 249, 1)",
                            fontSize: "0.75rem",
                            display: "flex",
                            fontFamily: "Poppins",
                            border: "none",
                            alignItems: "center",
                            justifyContent: "center",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-tag": {
                            bgcolor: "rgba(240, 243, 199, 1)",
                            color: "rgba(60, 101, 86, 1)",
                            border: "none",
                            borderColor: "primary.light",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "2px",
                          },
                          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                            color: "rgba(60, 101, 86, 1)",
                            "&:hover": {
                              color: "rgba(60, 101, 86, 1)",
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option === value}
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </DialogContent>
        <DialogActions>
          <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 54, 54, 1)",
                background: "rgba(255, 229, 229, 1)",
                width: "62px",
                height: "26px",
                borderRadius: "5.38px",
                marginRight: "10px",
                "&:hover": {
                  background: "rgba(255, 229, 229, 1)",
                },
              }}
              onClick={handleEditClose}
              color="secondary"
          >
            Annuler
          </Button>
          <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
                width: "61.08px",
                height: "26.71px",
                borderRadius: "5.38px",
                marginRight: "10px",
                "&:hover": {
                  background: "rgba(187, 200, 8, 1)",
                },
              }}
              onClick={handleEditSubmit}
              color="primary"
          >
            Modifier
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
          open={openDeleteDialog}
          onClose={cancelDeleteRepairer}
          aria-labelledby="delete-repairer-dialog-title"
          aria-describedby="delete-repairer-dialog-description"
      >
        <DialogTitle className={classes.dialogTitle} style={{display: "flex", justifyContent: "space-between"}}>Supprimer
          réparateur
          <IoCloseOutline className={classes.closeButton} size={24} onClick={cancelDeleteRepairer}/>
        </DialogTitle>
        <DialogContent>
          Êtes-vous sûr de vouloir supprimer le réparateur{" "}
          <strong>{repairerToDelete?.organizationName}</strong> ?
        </DialogContent>
        <DialogActions>
          <Button
              onClick={confirmDeleteRepairer}
              style={{
                width: "80px",
                marginLeft: "10px",
                height: "34px",
                borderRadius: "6px",
                background: "rgba(255, 229, 229, 1)",
                border: 0,
                fontFamily: "Poppins",
                fontSize: "12px",
                fontWeight: 600,
                lineHeight: "18px",
                color: "rgba(255, 54, 54, 1)",
              }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
